import React from "react";
import { IntentSlideUpBoxModel } from "../../models/IntentSlideUpBoxModel";
import {
  SetSessionIntentHide,
  GetSessionIntentHide,
} from "../../components/WebStorage";
import { observer } from "mobx-react";
import IntentCta from "./IntentCta";

interface IntentModalState {
  content: IntentSlideUpBoxModel;
  modelName: string;
  isVisible: boolean;
}

interface IntentModalProps {
  content: IntentSlideUpBoxModel;
  modelName: string;
}

@observer
export default class IntentBox extends React.Component<
  IntentModalProps,
  IntentModalState
> {
  constructor(props) {
    super(props);

    this.state = {
      content: this.props.content,
      modelName: this.props.modelName,
      isVisible: false,
    };
  }

  componentWillMount() {
    this.waitUntil(this.doWeShowIntent(), 2000);
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  componentDidMount() {
    if (this.state.isVisible) {
      this.disableScroll();
    } else {
      this.enableScroll();
    }
  }

  waitUntil = (callback, time) => {
    var intervalId = setInterval(() => {
      clearInterval(intervalId);
      callback();
    }, time);
  };

  disableScroll() {
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
  }

  enableScroll() {
    document.body.style.removeProperty("overflow");
    document.documentElement.style.removeProperty("overflow");
  }

  doWeShowIntent() {
    var isIntentHidden = GetSessionIntentHide() === 1 ? true : false;
    var showIntent = this.props.content.showIntentBox && !isIntentHidden;
    this.setState({
      isVisible: showIntent,
    });
  }

  handleKeyDown(e): boolean {
    if (this.state.isVisible && e.keyCode === 27) {
      this.close();
    }

    return true;
  }

  close() {
    SetSessionIntentHide();
    this.enableScroll();
    const isVisible = false;
    this.setState({ isVisible });
  }

  renderContent() {
    const { isVisible, content, modelName } = this.state;
    const { intentTitle, intentDescription, intentCtaBlocks } = content;

    return (
      <div
        className={`intentBox ${isVisible ? "intentVisible" : "intentHidden"}`}
      >
        <div
          onClick={(e) => {
            this.close();
          }}
          className="intentOverlay"
          style={
            isVisible
              ? {
                  visibility: "visible",
                  opacity: 1,
                }
              : {}
          }
        />
        <div
          className="intentContent"
          style={
            isVisible
              ? {
                  visibility: "visible",
                  opacity: 1,
                }
              : {}
          }
        >
          <span
            className="intentCloseButton"
            onClick={(e) => {
              this.close();
            }}
          >
            &#10006;
          </span>
          <div
            className="intentHeader"
            dangerouslySetInnerHTML={{ __html: intentTitle }}
          />
          <div className="intentDescription">{intentDescription}</div>
          {intentCtaBlocks && intentCtaBlocks.length > 0 && (
            <div className="intentCtasSection">
              {intentCtaBlocks.map((currCta) => {
                return <IntentCta content={currCta} modelName={modelName} />;
              })}
            </div>
          )}
        </div>
      </div>
    );
  }

  render() {
    const { isVisible, content } = this.state;

    return (
      <div className={`${isVisible ? "" : "hidden"}`}>
        {content ? this.renderContent() : null}
      </div>
    );
  }
}
